import React, { useState, useContext, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { Loader, Button } from 'semantic-ui-react';
import { toast } from 'react-toastify';

import UserContext from '../../../contexts/UserContext';
import RedirectContext from '../../../contexts/RedirectContext';
import { getActivity, toggleActivityArchivedStatus } from '../../../services/activities';
import News from '../../pages/news';

import './style.less';
import { type } from 'os';

interface Activity {
    _id: string;
    registrantId: string;
    registrantFirstName: string;
    registrantLastName: string;
    registrantImage: string;
    activityType: string;
    activityTime: number;
    activityTypeIcon: string;
    Name: string;
    ActivitySlots: object;
    isArchived: boolean;
}

const MessageDetail = ({ activitSlot }) => {
    const {
        repliedToStory: { type, text },
        reply,
    } = activitSlot;
    return (
        <>
            <div className="detail">Message: {type === 'text' ? text : type}</div>
            <div className="detail">Reply: {reply}</div>
        </>
    );
};

const ActivityDetail = () => {
    const {
        userObject: {
            registrants: { list: listOfResidents, activeRegistrantsIndexes },
        },
    } = useContext(UserContext);
    const toggleRedirect = useContext(RedirectContext);

    const residentId = listOfResidents[activeRegistrantsIndexes] && listOfResidents[activeRegistrantsIndexes]._id;

    const [activity, setActivity] = useState<Activity | null>();

    const [isLoading, setIsLoading] = useState(true);

    const { activityId } = useParams();

    const loadActivity = async () => {
        setIsLoading(true);
        const { activity: activityNew } = await getActivity(activityId);

        setActivity(activityNew);
        setIsLoading(false);
    };

    useEffect(() => {
        loadActivity();
    }, [activityId]);

    const isUserManagerOfRegistrant = () => {
        const residentDetails = listOfResidents.filter(
            (resident) => activity && resident._id === activity.registrantId,
        )?.[0];
        return residentDetails && residentDetails.manager === true;
    };

    const navigate = (to: string) => {
        toggleRedirect(to);
        return;
    };

    const sendToast = (type = 'warn', message) => {
        if (type === 'success') {
            toast.success(message, {
                position: 'bottom-center',
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
            });
        } else if (type === 'warn') {
            toast.warn(message, {
                position: 'bottom-center',
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
            });
        }
    };

    const toggleReqArchivedStatus = (requestId, isArchived) => {
        setIsLoading(true);
        toggleActivityArchivedStatus(requestId, isArchived)
            .then(() => {
                setIsLoading(false);
                sendToast('success', `${!isArchived ? 'Unarchived' : 'Archived'} the request`);
                return navigate('/activities');
            })
            .catch((err) => {
                sendToast('warn', err.message);
                return navigate('/activities');
            });
    };

    return (
        <div className="relative-list activity-detail">
            {isLoading && <Loader active={isLoading} />}
            {activity && (
                <div className="request-view mt-10">
                    <div>
                        {activity.registrantImage && (
                            <img className="tiny circular img circular-image" src={activity.registrantImage} alt="" />
                        )}
                    </div>
                    <div className="details">
                        <div className="title">{activity.Name}</div>
                        <div className="resident-name">{`${activity.registrantFirstName} ${activity.registrantLastName}`}</div>
                        {activity.activityType !== 'Message Reply' ? (
                            Object.entries(activity.ActivitySlots).map(([name, value]) => (
                                <div className="detail">{typeof value == 'object' ? '' : `${name}: ${value}`}</div>
                            ))
                        ) : (
                            <>{<MessageDetail activitSlot={activity.ActivitySlots} />}</>
                        )}
                        <div className="timestamp">Created: {new Date(activity.activityTime).toLocaleString()} </div>

                        <div className="requestControl">
                            {isUserManagerOfRegistrant() && (
                                <Button
                                    className="ui primary small button"
                                    type="button"
                                    loading={isLoading}
                                    onClick={(e) => {
                                        e.stopPropagation();
                                        toggleReqArchivedStatus(activity._id, !activity.isArchived);
                                    }}
                                >
                                    {activity.isArchived ? 'Unarchive' : 'Archive'}
                                </Button>
                            )}
                        </div>
                    </div>
                    <div>
                        {activity.activityTypeIcon && (
                            <img className="tiny circular img" src={activity.activityTypeIcon} alt="" />
                        )}
                    </div>
                </div>
            )}
            <div className="suppressed-news">
                <News suppressResidentInfo={true}/>
            </div>
        </div>
    );
};

export default ActivityDetail;
